export const sanitizeHtmlStyles = (html: string) => {
  // Remove style tags
  const withoutStyleTags = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
  // Remove style attributes
  const withoutStyleAttributes = withoutStyleTags.replace(/style="[^"]*"/gi, '');
  return withoutStyleAttributes;
};
